module.exports = __webpack_public_path__ + "img/zz1.2a720e72.png";